"use client"

import { useEffect, type ReactNode } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { initPostHog, capturePageview } from '@/lib/posthog'

export function PostHogProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initPostHog()
  }, [])

  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!pathname) return
    const url = window.location.origin + pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '')
    capturePageview(url)
  }, [pathname, searchParams])

  return <>{children}</>
}
